import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { EndpointsService } from '../core/services';
import { CampaignsFilterModel } from "./campaign-filter.model";
import { Campaign, PublisherCampaignAllocation, CampaignPpa } from './campaign.model';
import { FilterService, PublisherModel, NotificationService } from '../core/services';
import { DropdownValue } from '../shared/dropdown.model';

@Injectable()
export class CampaignsService {
    private static notificationService;
    private duplicatedCampaign: Campaign;
    constructor(private http: Http,
        private endpointsService: EndpointsService,
        private filterService: FilterService,
        private notificationService: NotificationService) {
        CampaignsService.notificationService = notificationService;
    }

    public duplicateCampaign(campaign: Campaign) {
        this.duplicatedCampaign = campaign;
    }

    public getDuplicatedCampaign(): Campaign {
        let campaign = this.duplicatedCampaign;
        this.duplicatedCampaign = null;
        return campaign;
    }

    public getFilteredCampaigns(sortFieldId: number, sortAsc: boolean, pageNumber: number, pageSize: number, filters: CampaignsFilterModel): Observable<Response> {
        let url = this.getFilteredCampaignsUrl(sortFieldId, sortAsc, pageNumber, pageSize, filters);
        return this.http.get(url)
            .catch(this.handleError);
    }

    public createCampaign(campaign: Campaign): Observable<Response> {
        return this.http.post(this.endpointsService.CREATE_CAMPAIGN_URL, campaign)
            .catch(this.handleError);
    }

    public updateCampaign(campaign: Campaign): Observable<Response> {
        return this.http.post(this.endpointsService.UPDATE_CAMPAIGN_URL, campaign)
            .catch(this.handleError);
    }


    public deleteCamapign(campaignId: number): Observable<Response> {
        return this.http.delete(this.endpointsService.DELETE_CAMPAIGN_URL + '/' + campaignId)
            .catch(this.handleError);
    }

    public getCamapign(campaignId: number): Observable<Response> {
        return this.http.get(this.endpointsService.GET_CAMPAIGN_URL + '/' + campaignId)
            .catch(this.handleError);
    }

    public getCamapignExtraDetails(campaignId: number): Observable<Response> {
        return this.http.get(this.endpointsService.GET_CAMPAIGN_EXTRA_DETAILS_URL + '/' + campaignId)
            .catch(this.handleError);
    }

    private getFilteredCampaignsUrl(sortFieldId: number, sortAsc: boolean, pageNumber: number, pageSize: number, filters: CampaignsFilterModel): string {
        let allPublishersSelected: boolean = false;
        if (filters.publisherIds.length === this.filterService.getPublisherIds().length)
            allPublishersSelected = true;
        return `${this.endpointsService.GET_FILTERED_CAMPAIGNS_URL}?sortFieldId=${sortFieldId}&sortAsc=${sortAsc}&isAvailable=${filters.isAvailable}&brand=${filters.brand}&product=${filters.product}&tradingDesk=${filters.tradingDesk}&dsp=${filters.dsp}&ssp=${filters.ssp}&publisherIds=${filters.publisherIds}&providerIds=${filters.providerIds}&countryIds=${filters.countryIds}&pageNumber=${pageNumber}&pageSize=${pageSize}&allPublishersSelected=${allPublishersSelected}&startDate=${filters.startDate}&endDate=${filters.endDate}`;
    }

    public getPublisherAllocations(response: any): Array<PublisherCampaignAllocation> {
        let list: Array<PublisherCampaignAllocation> = [];
        let publishers = this.filterService.getPublishers();

        if (response && response.publisherCampaignAllocations)
            for (let item of response.publisherCampaignAllocations) {
                item.publisherName = this.getPublisherName(publishers, item.publisherId);
                list.push(item);
            }

        return list;
    }

    public createPublisherAllocation(publisherCampaignAllocation: PublisherCampaignAllocation): Observable<Response> {
        return this.http.post(this.endpointsService.CREATE_PUBLISHER_CAMPAIGN_ALLOCATION_URL, publisherCampaignAllocation)
            .catch(this.handleError);
    }

    public updatePublisherAllocation(publisherCampaignAllocation: PublisherCampaignAllocation): Observable<Response> {
        return this.http.post(this.endpointsService.UPDATE_PUBLISHER_CAMPAIGN_ALLOCATION_URL, publisherCampaignAllocation)
            .catch(this.handleError);
    }

    public deletePublisherAllocation(publisherAllocationId: number): Observable<Response> {
        return this.http.delete(this.endpointsService.DELETE_PUBLISHER_CAMPAIGN_ALLOCATION_URL + '/' + publisherAllocationId)
            .catch(this.handleError);
    }

    public createPpa(campaignPpa: CampaignPpa): Observable<Response> {
        return this.http.post(this.endpointsService.CREATE_PPA_URL, campaignPpa)
            .catch(this.handleError);
    }

    public updatePpa(campaignPpa: CampaignPpa): Observable<Response> {
        return this.http.post(this.endpointsService.UPDATE_PPA_URL, campaignPpa)
            .catch(this.handleError);
    }

    public deletePpa(ppaId: number): Observable<Response> {
        return this.http.delete(this.endpointsService.DELETE_PPA_URL + '/' + ppaId)
            .catch(this.handleError);
    }

    public getPpaFields(ppaId: number): Observable<Response> {
        return this.http.get(this.endpointsService.GET_PPA_FIEDLS_URL + '/' + ppaId)
            .catch(this.handleError);
    }

    public getPpas(response: any): Array<CampaignPpa> {
        let list: Array<CampaignPpa> = [];

        if (response && response.campaignPpa)
            for (let item of response.campaignPpa) {
                item.ppaTypeName = this.getPpaTypeName(item.ppaType);
                list.push(item);
            }
        return list;
    }

    public getAllowedPublisherIdsByProviderAndCountry(providerId: number, countryId: number): Observable<Response> {
        return this.http.get(this.endpointsService.GET_ALLOWED_PUBLISHER_IDS_BY_PROVIDER_AND_COUNTRY + '?providerId=' + providerId + '&countryId=' + countryId)
            .catch(this.handleError);
    }

    public getAllowedPublisherIdsFromCarouselOrder(providerId: number, countryId: number): Observable<Response> {
        return this.http.get(this.endpointsService.GET_ALLOWED_PUBLISHER_IDS_FROM_CAROUSEL_ORDER + '?providerId=' + providerId + '&countryId=' + countryId)
            .catch(this.handleError);
    }

    getPublisherName(publishers: Array<PublisherModel>, publisherId: number) {
        let publisher = publishers.find(s => s.id === publisherId)
        if (publisher)
            return publisher.name;
        return null;
    }

    public getPpaTypes(): Array<DropdownValue> {
        let list: Array<DropdownValue> = [];
        list.push(new DropdownValue(1, 'Rate and Share'));
        list.push(new DropdownValue(2, 'Email Capture'));
        list.push(new DropdownValue(3, 'Survey'));

        return list;
    }

    public getBrandLogosForBrand(brandId: number): Observable<Response> {
        return this.http.get(this.endpointsService.GET_BRAND_LOGOS_LIST_URL + "?brandId=" + brandId)
            .catch(this.handleError);
    }

    public getBrandForLogo(brandLogoId: number): Observable<Response> {
        return this.http.get(this.endpointsService.GET_BRAND_BY_LOGO_URL + "?brandLogoId=" + brandLogoId)
            .catch(this.handleError);
    }

    private getPpaTypeName(ppaTypeId: number): string {
        let ppa = this.getPpaTypes().find(s => s.value === ppaTypeId);
        if (ppa)
            return ppa.label;
        return null;
    }

    private handleError(error: Response) {
        if (error.status === 400)
            CampaignsService.notificationService.showError(error.json().message)
        else
            CampaignsService.notificationService.showError();
        return Observable.throw(error.json().error || 'Server Error');
    }
}


// WEBPACK FOOTER //
// ./src/app/campaigns/campaigns.service.ts